import { MODAL_BODY_TYPES } from "../utils/globalConstantUtil";
import { useSelector, useDispatch } from "react-redux";
import { closeModal } from "../features/common/modalSlice";
import AddLeadModalBody from "../features/leads/components/AddLeadModalBody";
import ConfirmationModalBody from "../features/common/components/ConfirmationModalBody";
import AddMessageModalBody from "../features/adminmessages/components/AddMessageModalBody";
import EditMessageModalBody from "../features/adminmessages/components/EditMessageModalBody";
import DeleteMessageModalBody from "../features/adminmessages/components/DeleteMessageModalBody";
import ImportSundayMessagesFromCSVModalBody from "../features/adminmessages/components/ImportSundayMessagesFromCSVModalBody";
import AddSpecialMessageModalBody from "../features/adminspecialmessages/components/AddSpecialMessageModalBody";
import AddSpecialMeetingModalBody from "../features/adminspecialmeetings/components/AddSpecialMeetingModalBody";
import DeleteSpecialMeetingModalBody from "../features/adminspecialmeetings/components/DeleteSpecialMeetingModalBody";
import ImportSpecialMeetingFromCSVModalBody from "../features/adminspecialmeetings/components/ImportSpecialMeetingFromCSVModalBody";
import ImportSpecialMessagesFromCSVModalBody from "../features/adminspecialmessages/components/ImportSpecialMessagesFromCSVModalBody";
import AddBulletinModalBody from "../features/adminbulletins/components/AddBulletinModalBody";
import DeleteBulletinModalBody from "../features/adminbulletins/components/DeleteBulletinModalBody";
import AddScheduleModalBody from "../features/adminschedules/components/AddScheduleModalBody";
import EditScheduleModalBody from "../features/adminschedules/components/EditScheduleModalBody";
import DeleteScheduleModalBody from "../features/adminschedules/components/DeleteScheduleModalBody";
import AddServiceRoleModalBody from "../features/adminservices/components/AddServiceRoleModalBody";
import EditServiceRoleModalBody from "../features/adminservices/components/EditServiceRoleModalBody";
import DeleteServiceRoleModalBody from "../features/adminservices/components/DeleteServiceRoleModalBody";

function ModalLayout() {
  const { isOpen, bodyType, size, extraObject, title } = useSelector(
    (state) => state.modal,
  );
  const dispatch = useDispatch();

  const close = (e) => {
    dispatch(closeModal(e));
  };

  return (
    <>
      {/* The button to open modal */}

      {/* Put this part before </body> tag */}
      <div className={`modal ${isOpen ? "modal-open" : ""}`}>
        <div className={`modal-box max-h-[80vh] overflow-y-auto ${size === "lg" ? "max-w-2xl" : ""}`}>
          <button
            className="btn btn-sm btn-circle absolute right-2 top-2"
            onClick={() => close()}
          >
            ✕
          </button>
          <h3 className="font-semibold text-2xl pb-6 text-center">{title}</h3>

          {/* Loading modal body according to different modal type */}
          {
            {
              [MODAL_BODY_TYPES.LEAD_ADD_NEW]: (
                <AddLeadModalBody
                  closeModal={close}
                  extraObject={extraObject}
                />
              ),
              [MODAL_BODY_TYPES.CONFIRMATION]: (
                <ConfirmationModalBody
                  extraObject={extraObject}
                  closeModal={close}
                />
              ),
              [MODAL_BODY_TYPES.MESSAGE_ADD_NEW]: (
                <AddMessageModalBody
                  closeModal={close}
                  extraObject={extraObject}
                />
              ),
              [MODAL_BODY_TYPES.MESSAGE_EDIT] : (
                <EditMessageModalBody
                  closeModal={close}
                  extraObject={extraObject}
                />
              ),
              [MODAL_BODY_TYPES.MESSAGE_DELETE] : (
                <DeleteMessageModalBody
                  closeModal={close}
                  extraObject={extraObject}
                />
              ),
              [MODAL_BODY_TYPES.IMPORT_FROM_CSV] : (
                <ImportSundayMessagesFromCSVModalBody
                  closeModal={close}
                  extraObject={extraObject}
                />
              ),
              [MODAL_BODY_TYPES.BULLETIN_ADD_NEW]: (
                <AddBulletinModalBody
                  closeModal={close}
                  extraObject={extraObject}
                />
              ),
              [MODAL_BODY_TYPES.BULLETIN_DELETE] : (
                <DeleteBulletinModalBody
                  closeModal={close}
                  extraObject={extraObject}
                />
              ),
              [MODAL_BODY_TYPES.SPECIAL_MESSAGE_ADD_NEW]: (
                <AddSpecialMessageModalBody
                  closeModal={close}
                  extraObject={extraObject}
                />
              ),
              [MODAL_BODY_TYPES.SPECIAL_MESSAGE_EDIT] : (
                <EditMessageModalBody
                  closeModal={close}
                  extraObject={extraObject}
                />
              ),
              [MODAL_BODY_TYPES.SPECIAL_MESSAGE_DELETE] : (
                <DeleteMessageModalBody
                  closeModal={close}
                  extraObject={extraObject}
                />
              ),
              [MODAL_BODY_TYPES.SPECIAL_IMPORT_FROM_CSV] : (
                <ImportSpecialMessagesFromCSVModalBody
                  closeModal={close}
                  extraObject={extraObject}
                />
              ),
              [MODAL_BODY_TYPES.SPECIAL_MEETING_ADD_NEW]: (
                <AddSpecialMeetingModalBody
                  closeModal={close}
                  extraObject={extraObject}
                />
              ),
              [MODAL_BODY_TYPES.SPECIAL_MEETING_DELETE] : (
                <DeleteSpecialMeetingModalBody
                  closeModal={close}
                  extraObject={extraObject}
                />
              ),
              [MODAL_BODY_TYPES.SPECIAL_MEETING_IMPORT_FROM_CSV] : (
                <ImportSpecialMeetingFromCSVModalBody
                  closeModal={close}
                  extraObject={extraObject}
                />
              ),
              [MODAL_BODY_TYPES.SCHEDULE_ADD_NEW] : (
                <AddScheduleModalBody
                  closeModal={close}
                  extraObject={extraObject}
                />
              ),
              [MODAL_BODY_TYPES.SCHEDULE_EDIT] : (
                <EditScheduleModalBody
                  closeModal={close}
                  extraObject={extraObject}
                />
              ),
              [MODAL_BODY_TYPES.SCHEDULE_DELETE] : (
                <DeleteScheduleModalBody
                  closeModal={close}
                  extraObject={extraObject}
                />
              ),
              [MODAL_BODY_TYPES.SERVICE_ROLE_ADD_NEW] : (
                <AddServiceRoleModalBody
                  closeModal={close}
                  extraObject={extraObject}
                />
              ),
              [MODAL_BODY_TYPES.SERVICE_ROLE_EDIT] : (
                <EditServiceRoleModalBody
                  closeModal={close}
                  extraObject={extraObject}
                />
              ),
              [MODAL_BODY_TYPES.SERVICE_ROLE_DELETE] : (
                <DeleteServiceRoleModalBody
                  closeModal={close}
                  extraObject={extraObject}
                />
              ),
              [MODAL_BODY_TYPES.DEFAULT]: <div></div>,
            }[bodyType]
          }
        </div>
      </div>
    </>
  );
}

export default ModalLayout;
